import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _class, _TrueFalseEdit;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import getOr from 'lodash/fp/getOr';
import t from '@instructure/quiz-i18n/format-message';
import ChoiceBody from '../components/ChoiceBody';
import QuestionSettingsContainer from '../../common/edit/components/QuestionSettingsContainer';
import QuestionContainer from '../../common/edit/components/QuestionContainer';
import TrueFalseInteractionType from '../../../records/interactions/true_false';
import withEditTools from '../../../util/withEditTools';
import QuestionSettingsPanel from '../../common/edit/components/QuestionSettingsPanel';
import CalculatorOptionWithOqaatAlert from '../../common/edit/components/CalculatorOptionWithOqaatAlert';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { FormFieldGroup } from '@instructure/quiz-common';
var TRUE_VALUE = 'trueChoice';
var FALSE_VALUE = 'falseChoice';

/**
---
category: TrueFalse
---
  True False Edit component

   ```jsx_example
   function Example (props) {
    const exampleProps = {
      itemId: '1',
      itemBody: 'The sun is a star',
      interactionData: {
        trueChoice: 'True',
        falseChoice: 'False'
      },
      scoringData: { value: true }
    }

    return (
      <TrueFalseEdit {...exampleProps} {...props} />
    )
  }

  <SettingsSwitcher locales={LOCALES}>
    <EditStateProvider>
      <Example />
    </EditStateProvider>
  </SettingsSwitcher>
  ```
**/
var TrueFalseEdit = withEditTools(_class = (_TrueFalseEdit = /*#__PURE__*/function (_Component) {
  function TrueFalseEdit() {
    var _this2;
    _classCallCheck(this, TrueFalseEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, TrueFalseEdit, [].concat(args));
    _defineProperty(_this2, "stemElement", null);
    _defineProperty(_this2, "handleCalculatorTypeChange", function (e, value) {
      _this2.props.changeItemState({
        calculatorType: value
      });
    });
    _defineProperty(_this2, "handleSelectionUpdate", function (event, newChoice) {
      _this2.props.changeItemState({
        scoringData: _objectSpread(_objectSpread({}, _this2.props.scoringData), {}, {
          value: newChoice === TRUE_VALUE
        })
      });
    });
    _defineProperty(_this2, "handleStemRef", function (node) {
      _this2.stemElement = node;
    });
    _defineProperty(_this2, "focusErrors", function () {
      var stemErrors = getOr([], 'itemBody', _this2.props.errors);
      if (stemErrors.length) {
        _this2.stemElement.focus();
      }
    });
    return _this2;
  }
  _inherits(TrueFalseEdit, _Component);
  return _createClass(TrueFalseEdit, [{
    key: "renderOptionsDescription",
    value: function renderOptionsDescription() {
      return /*#__PURE__*/React.createElement(ScreenReaderContent, null, t('True or false options'));
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(QuestionContainer, {
        disabled: this.props.overrideEditableForRegrading,
        enableRichContentEditor: this.props.enableRichContentEditor,
        itemBody: this.props.itemBody,
        onDescriptionChange: this.props.onDescriptionChange,
        onModalClose: this.props.onModalClose,
        onModalOpen: this.props.onModalOpen,
        openImportModal: this.props.openImportModal,
        stemErrors: this.props.getErrors('itemBody'),
        textareaRef: this.handleStemRef
      }, /*#__PURE__*/React.createElement(ChoiceBody, {
        selectedValue: this.props.scoringData.value ? TRUE_VALUE : FALSE_VALUE,
        falseChoiceLabel: this.props.interactionData.falseChoice,
        name: "edit_interaction_".concat(this.props.itemId),
        onSelectionUpdate: this.handleSelectionUpdate,
        trueChoiceLabel: this.props.interactionData.trueChoice,
        itemBody: this.props.itemBody,
        screenreaderOnlyDescription: true
      })), /*#__PURE__*/React.createElement(QuestionSettingsContainer, {
        additionalOptions: this.props.additionalOptions
      }, this.props.showCalculatorOption && /*#__PURE__*/React.createElement(QuestionSettingsPanel, {
        label: t('Options'),
        defaultExpanded: true
      }, /*#__PURE__*/React.createElement(FormFieldGroup, {
        rowSpacing: "small",
        description: this.renderOptionsDescription()
      }, /*#__PURE__*/React.createElement(CalculatorOptionWithOqaatAlert, {
        disabled: this.props.overrideEditableForRegrading,
        calculatorValue: this.props.calculatorType,
        onCalculatorTypeChange: this.handleCalculatorTypeChange,
        oqaatChecked: this.props.oneQuestionAtATime,
        onOqaatChange: this.props.setOneQuestionAtATime
      })))));
    }
  }]);
}(Component), _defineProperty(_TrueFalseEdit, "interactionType", TrueFalseInteractionType), _defineProperty(_TrueFalseEdit, "propTypes", _objectSpread(_objectSpread({
  additionalOptions: QuestionSettingsContainer.propTypes.additionalOptions,
  calculatorType: PropTypes.string,
  changeItemState: PropTypes.func,
  enableRichContentEditor: PropTypes.bool,
  interactionData: PropTypes.shape({
    trueChoice: PropTypes.string,
    falseChoice: PropTypes.string
  }).isRequired,
  itemBody: PropTypes.string.isRequired,
  itemId: PropTypes.string,
  onModalClose: PropTypes.func,
  onModalOpen: PropTypes.func,
  oneQuestionAtATime: PropTypes.bool,
  openImportModal: PropTypes.func,
  overrideEditableForRegrading: PropTypes.bool,
  scoringData: PropTypes.shape({
    value: PropTypes.bool
  }).isRequired,
  setOneQuestionAtATime: PropTypes.func
}, withEditTools.injectedProps), {}, {
  showCalculatorOption: PropTypes.bool
})), _defineProperty(_TrueFalseEdit, "defaultProps", {
  additionalOptions: void 0,
  calculatorType: 'none',
  changeItemState: void 0,
  enableRichContentEditor: true,
  itemId: void 0,
  onModalClose: void 0,
  onModalOpen: void 0,
  oneQuestionAtATime: false,
  openImportModal: void 0,
  overrideEditableForRegrading: false,
  setOneQuestionAtATime: Function.prototype,
  showCalculatorOption: true
}), _TrueFalseEdit)) || _class;
export { TrueFalseEdit as default };